import { useSelector } from 'react-redux'

import {
  productInformationSelectors,
  ProductInfo,
} from '../../state/slices/productInformation'

function useProductInformation() {
  const productInformation = useSelector(productInformationSelectors.productInformation)

  return productInformation || {}
}

export function useProductInfo(): ProductInfo {
  const productInformation = useProductInformation()

  return productInformation.productInfo || {
    name: '',
    type: '',
    categories: [],
    distributionMethods: [],
    privacyPolicyIntroduction: '',
  }
}

export default useProductInformation

export * from '../../state/slices/productInformation'
